import React, { Component } from 'react';
import iconMinus from '../../static/img/icon-minus.png'
import iconPlus from '../../static/img/icon-plus.png'

class PootsyStepper extends Component {

	constructor(props) {
		super(props)

		this.state = {
			currentValue: props.initialValue ? props.initialValue : 0
		}
	}

	render() {
		return (
			<div className="PootsyStepper">
				<div className={"button" + (!this.isLessButtonEnabled() ? " disabled" : "")} onClick={this.onLessClick}>
					<img alt="" className="icon" src={iconMinus}/>
				</div>

				<div className="value">{this.state.currentValue}</div>

				<div className={"button" + (!this.isMoreButtonEnabled() ? " disabled" : "")} onClick={this.onMoreClick}>
					<img alt="" className="icon" src={iconPlus}/>
				</div>
			</div>
		)
	}

	onLessClick = () => {
		if (this.isLessButtonEnabled()) {
			let newValue = this.state.currentValue - 1
			this.setState({ currentValue: newValue })
			this.triggerChangeEvent(newValue)
		}
	}

	onMoreClick = () => {
		if (this.isMoreButtonEnabled()) {
			let newValue = this.state.currentValue + 1
			this.setState({ currentValue: newValue })
			this.triggerChangeEvent(newValue)
		}
	}

	isLessButtonEnabled = () => {
		let minValue = this.props.minValue ? this.props.minValue : 0
		return this.state.currentValue > minValue
	}

	isMoreButtonEnabled = () => {
		let maxValue = this.props.maxValue ? this.props.maxValue : Number.MAX_SAFE_INTEGER
		return this.state.currentValue < maxValue
	}

	triggerChangeEvent = (newValue) => {
		if (this.props.onValueChanged) {
			this.props.onValueChanged(newValue)
		}
	}
}

export default PootsyStepper;


// WEBPACK FOOTER //
// ./src/components/shared/PootsyStepper.js